/**
 * HxTabPanel Directive
 *
 * Directive for marking template content that belongs to a specific tab. Used with ng-template for content projection
 * in HxTabbedView.
 *
 * @example
 *   ```html
 *   <hx-tabbed-view [tabs]="myTabs">
 *     <ng-template hxTabPanel="tab1">
 *       <div>Content for Tab 1</div>
 *     </ng-template>
 *     <ng-template hxTabPanel="tab2">
 *       <div>Content for Tab 2</div>
 *     </ng-template>
 *   </hx-tabbed-view>
 *   ```;
 *
 * @package @complexcare/harmony
 * @feature 043-harmony-tabbed-view
 */
import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[hxTabPanel]',
  standalone: true,
})
export class HxTabPanelDirective {
  /** The key of the tab this panel belongs to. Must match a key in the tabs array of the parent HxTabbedView. */
  readonly hxTabPanel = input.required<string>();

  /**
   * Template reference for the content to display when tab is active.
   *
   * @internal
   */
  readonly templateRef = inject(TemplateRef<unknown>);
}
